import { DEFAULT_URL_UPLOAD } from '../constants/common.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const UPLOAD_ATTACHMENT_URL = `${DEFAULT_URL_UPLOAD}/pacs/connect/attachment/bulk-meta`;
const ATTACHMENT_URL = `${DEFAULT_URL_UPLOAD}/pacs/connect/attachment`;

export interface ResponseGetKeyImages extends DefaultResponse {
  data: {
    key_images: {
      data_uri: string;
      desc: string;
      imageSrc?: string;
    }[];
  };
}
export const getKeyImages = async (study_instance_uid: string) => {
  const response = (await api({
    url: `${ATTACHMENT_URL}/key-images/${study_instance_uid}`,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetKeyImages>;

  const promises = (response?.data?.data?.key_images || []).map(
    async (keyImage) =>
      api({
        url: keyImage.data_uri,
        baseURL: process.env.BACKEND_URL || window.origin,
        method: 'GET',
        timeout: 30_000,
        responseType: 'arraybuffer',
      })
  );

  return await Promise.all(promises)
    .then((res) => {
      return res.map((it, idx) => {
        return {
          ...response.data.data.key_images[idx],
          imageSrc:
            'data:' +
            it.headers['content-type'] +
            ';base64,' +
            Buffer.from(it.data, 'binary').toString('base64'),
        };
      });
    })
    .catch((error) => {
      console.log(error);

      return [];
    });
};

export interface CreateMetadataParams {
  filenames: string[];
  study_instance_uid: string;
  timezone?: string;
  usecase?: string;
}

export interface CreateMetadataResponse {
  code: number;
  message: string;
  data: {
    metadata: {
      filename: string;
      metadata: {
        [key: string]: {
          vr: string;
          Value?: string[];
          BulkDataURI?: string;
        };
      };
    }[];
  };
}

export const createMetadata = async (data: CreateMetadataParams) => {
  const response = (await api({
    url: UPLOAD_ATTACHMENT_URL,
    method: 'POST',
    data: {
      ...data,
      timezone:
        data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      usecase: data.usecase || 'study_attachment',
    },
  })) as AxiosResponse<CreateMetadataResponse>;

  return response.data;
};
